import { graphql, useFragment } from 'react-relay';
import { useFinishedSurveyCardFragmentQuery_surveyRef$key } from './__generated__/useFinishedSurveyCardFragmentQuery_surveyRef.graphql';

const fragment = graphql`
  fragment useFinishedSurveyCardFragmentQuery_surveyRef on Survey {
    id
    title
    status
    statusDescription
    supportId
    surveyId
    studyId
    tags
    startedAt
    rewardAmount {
      formatted
    }
    durationDetails {
      providerDuration
    }
  }
`;

export function useFinishedSurveyCardFragmentQuery(
  surveyRef: useFinishedSurveyCardFragmentQuery_surveyRef$key,
) {
  return useFragment<useFinishedSurveyCardFragmentQuery_surveyRef$key>(fragment, surveyRef);
}
